import type { SpacerSection as SpacerSectionType } from '@shared/lib/page-sections/types';

export default function SpacerSection({ section }: { section: SpacerSectionType }) {
  const rem = Math.max(0.5, Math.min(12, section.size ?? 4));
  return <div aria-hidden="true" style={{ height: `${rem}rem` }} />;
}
